<template>
	<form-item class="form_checkbox" :label="$attrs.label">
		<div class="checkbox__inner">
			<van-row gutter="14" v-for="(item, index) in getOptions" :key="`row_${ index }`">
				<van-col :span="8" v-for="(val, idx) in item" :key="`col_${ idx }`">
					<van-button
						v-if="val"
						:type="modelValue.includes(val) ? 'primary' : 'default'"
						plain
						block
						@click="modelValue = val"
					>
						{{ val }}
					</van-button>
					<van-button plain block v-else class="hide"></van-button>
				</van-col>
			</van-row>
		</div>
		<transition name="van-fade" mode="out-in">
			<form-input
				v-if="showInput"
				v-model="inputValue"
				class="mt-28"
				type="textarea"
				:maxlength="inputMaxLength"
				show-word-limit
				:preview="preview"
				:placeholder="inputPlaceholder || '请输入内容'"
				@blur="blurInput"
			></form-input>
		</transition>
	</form-item>
</template>

<script>
	export default {
		name: 'FormCheckbox',
		data: () => ({
			colNum: 3,
			inputValue: ''
		}),
		props: {
			value: {
				type: Array,
				default: () => []
			},
			checkboxType: {
				type: String,
				default: ''
			},
			options: {
				type: Array,
				default: () => []
			},
			// 互斥锁
			mutex: {
				type: [Array],
				default: () => []
			},
			// 文本框对应的文字内容
			showInputStr: {
				type: String,
				default: ''
			},
			inputPlaceholder: {
				type: String,
				default: ''
			},
			inputMaxLength: {
				type: [String, Number],
				default: 500
			},
			preview: {
				type: Boolean,
				default: false
			}
		},
		computed: {
			modelValue: {
				get() {
					const optionsExistItemList = this.value.filter(item => this.options.includes(item))
					if (optionsExistItemList.length < this.value.length) {
						optionsExistItemList.push(this.showInputStr)
					}
					return optionsExistItemList
				},
				set(val) {
					if (this.preview) return
					const value = this.modelValue

					// 文本框输入的val === 互斥锁的值，按互斥处理
					if (this.mutex.includes(val)) {
						this.$emit('input', [val])
						return
					}

					// 选中互斥锁内容时的逻辑操作
					if (value.length && this.mutex.includes(value[0])) {
						this.$emit('input', [val])
						return
					}

					// 文本框输入内容时的操作
					if (!this.options.includes(val)) {
						if (val === this.showInputStr) {
							this.inputValue = ''
							return
						}
						const otherIndex = value.indexOf(this.showInputStr)
						value.splice(otherIndex, 1, val)
						this.$emit('input', value)
						return
					}

					if (val === this.showInputStr && value.includes(val)) {
						const valIndex = value.indexOf(val)
						value.splice(valIndex, 1)
						this.$emit('input', value)
						return
					}

					// 如果有 showInputStr 值，就将其替换成 inputValue
					if (value.includes(this.showInputStr)) {
						const otherIndex = value.indexOf(this.showInputStr)
						value.splice(otherIndex, 1, this.inputValue)
					}
					value.includes(val) ? value.splice(value.indexOf(val), 1) : value.push(val)
					this.$emit('input', value)
				}
			},
			showInput () {
				return this.modelValue.includes(this.showInputStr)
			},
			getOptions() {
				let options = this.options
				if (this.preview) {
					options = this.modelValue
				} else if (this.options.length <= this.colNum) {
					return [this.options]
				}

				const list = options.reduce((val, item) => {
					if (!val.length || !(val[val.length - 1].length ^ this.colNum)) val[val.length] = [item]
					else val[val.length - 1].push(item)
					return val
				},[])

				const lastChildLen = list[list.length - 1].length
				if (lastChildLen < this.colNum) {
					list[list.length - 1] = [...list[list.length - 1], ...new Array(this.colNum - lastChildLen).fill('')]
				}

				return list
			}
		},
		watch: {
			'value' (newVal) {
				// value 值发生改变时，检测是否有文本框内容，有的话就赋值
				const otherItem = newVal.find(item => !this.options.includes(item))
				if (otherItem) {
					this.inputValue = otherItem
				}
			}
		},
		methods: {
			blurInput () {
				if (this.inputValue.trim()) {
					if (this.options.includes(this.inputValue)) {
						this.inputValue = ''
						this.$toast('输入的内容在选项中存在，请直接选择选项')
					} else {
						this.modelValue = this.inputValue
					}
				}
			}
		}
	};
</script>

<style scoped lang="less">
	.form_checkbox {
		.checkbox__inner {
			>div + div { margin-top: 28px; }
		}
	}
</style>
<style lang="less">
	.form_checkbox {
		.checkbox__inner {
			.van-button {
				height: 80px;
				border-radius: 10px;
				font-size: 30px;
				font-weight: normal;
				padding: 0;
				&.van-button--default {
					border-color: #F5F6F7;
					background-color: #F5F6F7;
					color: #1F2329;
				}
				&.van-button--primary {
					background-color: mix(@white, @primary, 90%);
				}
			}
		}
	}
</style>
